import _ from 'lodash'

export default {
  generate(prefix, identifier) {
    if (_.isString(identifier)) {
      identifier = identifier.toLowerCase()
      return `${prefix}-${identifier}`
    }
    return prefix
  }
}



// WEBPACK FOOTER //
// ./scripts/services/Acceptance.js